export default __webpack_public_path__ + "static/media/foto-imagem.98c87075.svg";